<template>
  <VCard flat>
    <VForm
      v-model="isFormValid"
      @submit.prevent="editPassword"
    >
      <VCardText>
        <VTextField
          v-model="oldPassword"
          :append-icon="showOldPassword ? 'visibility_off' : 'visibility'"
          :type="showOldPassword ? 'text' : 'password'"
          :rules="[$rules.isRequired, $rules.isValidPassword]"
          name="password-confirm-input"
          :label="$nt('labelConfirm')"
          min="8"
          counter
          required
          @click:append="showOldPassword = !showOldPassword"
        />
        <PasswordPair
          @submit="editPassword"
          @validPasswordPair="newPw => newPassword = newPw"
          @invalidPasswordPair="newPassword = ''"
        />
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          type="submit"
          :disabled="isFormEmpty || !isFormValid || isLoading"
          :loading="isLoading"
          color="primary"
        >
          {{ $nt('edit') }}
        </VBtn>
      </VCardActions>
    </VForm>
  </VCard>
</template>

<script>
import UserApi from '@/api/UserApi'
import PasswordPair from '@/components/global-components/inputs/PasswordPair.vue'

export default {
  name: 'PasswordSettings',
  components: { PasswordPair },
  props: [],
  data () {
    return {
      isLoading: false,
      isFormValid: false,
      showOldPassword: false,
      oldPassword: '',
      newPassword: ''
    }
  },
  computed: {
    isFormEmpty () {
      return !this.oldPassword.trim() || !this.newPassword.trim()
    }
  },
  methods: {
    async editPassword () {
      if (this.isFormValid) {
        try {
          this.isLoading = true
          const result = await UserApi.updatePassword({
            old_password: this.oldPassword,
            password: this.newPassword,
            password_confirmation: this.newPassword
          })
          this.$notification(result)
        } catch (e) {
          this.$notification(e)
        }
        this.isLoading = false
      }
    }
  }
}
</script>
